import React from 'react';
import fr from 'facet-rest';

import useUserContext from 'Context/UserContext';
import { pickComponentAndProps } from 'Helpers/Affordances';
import MissionControlDefault from './Versions/Default';

export default function MissionControl() {
  const { userResource } = useUserContext();
  const { component: DialogComponent } = pickComponentAndProps(userResource, {
    [fr.relationships.default.name]: [MissionControlDefault, {}],
  });

  return <DialogComponent />;
}
